/**
 * RFC6749 で定義 https://datatracker.ietf.org/doc/html/rfc6749#section-4.1.2
 */
export function hasAuthSuccessParams(
  searchParams: URLSearchParams = new URL(window.location.href).searchParams
): boolean {
  if (searchParams.has('error')) {
    return false;
  }
  return searchParams.has('code') && searchParams.has('state');
}

/**
 * 実 url から code / state を削除したものに replace する
 * 他の search param は残す必要がある
 */
export function deleteAuthSuccessParams() {
  const url = new URL(window.location.href);
  url.searchParams.delete('code');
  url.searchParams.delete('state');
  const search = url.searchParams.size > 0 ? `?${url.searchParams.toString()}` : '';

  history.replaceState(null, '', `${window.location.pathname}${search}`);
}

/**
 * RFC6749 で定義 https://datatracker.ietf.org/doc/html/rfc6749#section-4.1.2.1
 */
export function hasAuthErrorParams(
  searchParams: URLSearchParams = new URL(window.location.href).searchParams
): boolean {
  return searchParams.has('error');
}

export function getErrorDescriptionParam(
  searchParams: URLSearchParams = new URL(window.location.href).searchParams
): string | undefined {
  // auth0 actions で deny 時に定義する
  return searchParams.get('error_description') ?? undefined;
}
